import React from "react";
import "./SoftwareSolutionsSection1.css";
import illustration from "../../../assets/softwaresoltop.png";
import { useTranslation } from "react-i18next";

const SoftwareSolutionsSection1 = () => {
  const { t } = useTranslation("global");
  return (
    <section className="smart-software">
      <article className="content-software">
        <h1>
          {t("softwareSolutions.softwareSolutions1.word1")}
          <span className="highlight">
            {" "}
            {t("softwareSolutions.softwareSolutions1.word2")}
          </span>
          <br /> {t("softwareSolutions.softwareSolutions1.word3")}
        </h1>
        <p>{t("softwareSolutions.softwareSolutions1.text")}</p>
      </article>
      <figure className="illustration">
        <img src={illustration} alt="Illustration of team collaboration" />
      </figure>
    </section>
  );
};

export default SoftwareSolutionsSection1;
